<template>
    <div>
        <h4><b>{{declaration.title}}</b></h4>
        <div class="container-items">
            <Indicador
                v-for="(indicador, index) in declaration.items"
                :key="index"
                :declaration="indicador"
                :color="getColor(index)"
            />
        </div>
    </div>
</template>

<script>
import Indicador from './Indicador.vue';
export default {
    name:'ListaIndicadores',
    props:{
        declaration: Object,
    },
    components:{
        Indicador
    },
    data(){
        return{
            colors:['bg-muted','bg-primary', 'bg-success', 'bg-danger', 'bg-info', 'bg-warning' ]
        }
    },
    methods:{
        getColor(i){
            return (i < 5) ? this.colors[i] : this.colors[5];
        }
    }
}
</script>

<style lang="scss">

.container-items{
    display: flex;
    flex-direction: column;
}

</style>
